import { Link } from 'react-router-dom';
import { t } from '../../hooks/useT';

export function LandingMarketing() {
  const features = [
    { title: t('marketing.featureDaily'), desc: t('marketing.featureDailyDesc'), to: '/play' },
    { title: t('marketing.featureArchives'), desc: t('marketing.featureArchivesDesc'), to: '/archives' },
    { title: t('marketing.featureLeaderboard'), desc: t('marketing.featureLeaderboardDesc'), to: '/leaderboard' },
    { title: t('marketing.featureTop'), desc: t('marketing.featureTopDesc'), to: '/top' },
  ];

  const faq = [
    { q: t('marketing.faq1q'), a: t('marketing.faq1a') },
    { q: t('marketing.faq2q'), a: t('marketing.faq2a') },
    { q: t('marketing.faq3q'), a: t('marketing.faq3a') },
    { q: t('marketing.faq4q'), a: t('marketing.faq4a') },
    { q: t('marketing.faq5q'), a: t('marketing.faq5a') },
    { q: t('marketing.faq6q'), a: t('marketing.faq6a') },
  ];

  return (
    <div className="landing-marketing">
      <section className="marketing-section">
        <p className="marketing-intro">{t('marketing.intro')}</p>
      </section>

      <section className="marketing-section">
        <h2 className="marketing-heading">{t('marketing.howTitle')}</h2>
        <ol className="marketing-steps">
          <li>
            <span className="marketing-step-num">1</span>
            <div>
              <strong>{t('marketing.step1Title')}</strong>
              <p>{t('marketing.step1Desc')}</p>
            </div>
          </li>
          <li>
            <span className="marketing-step-num">2</span>
            <div>
              <strong>{t('marketing.step2Title')}</strong>
              <p>{t('marketing.step2Desc')}</p>
            </div>
          </li>
          <li>
            <span className="marketing-step-num">3</span>
            <div>
              <strong>{t('marketing.step3Title')}</strong>
              <p>{t('marketing.step3Desc')}</p>
            </div>
          </li>
        </ol>
      </section>

      <section className="marketing-section">
        <h2 className="marketing-heading">{t('marketing.featuresTitle')}</h2>
        <div className="feature-grid">
          {features.map((f) => (
            <Link key={f.to} to={f.to} className="feature-card">
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className="marketing-section">
        <h2 className="marketing-heading">{t('marketing.compareTitle')}</h2>
        <div className="compare-table-wrap">
        <table className="compare-table">
          <thead>
            <tr>
              <th>{t('marketing.compareFeature')}</th>
              <th>{t('marketing.compareFree')}</th>
              <th>{t('marketing.comparePremium')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t('marketing.compareDaily')}</td>
              <td>✓</td>
              <td>✓</td>
            </tr>
            <tr>
              <td>{t('marketing.compareArchives')}</td>
              <td>✓</td>
              <td>✓</td>
            </tr>
            <tr>
              <td>{t('marketing.compareLeaderboard')}</td>
              <td>✓</td>
              <td>✓</td>
            </tr>
            <tr>
              <td>{t('marketing.compareAds')}</td>
              <td>{t('marketing.compareAdsYes')}</td>
              <td>{t('marketing.compareAdsNo')}</td>
            </tr>
            <tr>
              <td>{t('marketing.compareSupport')}</td>
              <td>—</td>
              <td>✓</td>
            </tr>
          </tbody>
        </table>
        </div>
        <p className="marketing-compare-note">{t('marketing.compareNote')}</p>
        <Link to="/premium" className="btn secondary">{t('marketing.compareCta')}</Link>
      </section>

      <section className="marketing-section">
        <h2 className="marketing-heading">{t('marketing.faqTitle')}</h2>
        <dl className="faq-list">
          {faq.map((item) => (
            <div key={item.q} className="faq-item">
              <dt>{item.q}</dt>
              <dd>{item.a}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="marketing-section marketing-cta-band">
        <h2 className="marketing-heading">{t('marketing.finalCtaTitle')}</h2>
        <p>{t('marketing.finalCtaDesc')}</p>
        <div className="cta-row cta-row-single">
          <Link to="/play" className="btn primary">{t('landing.cta')}</Link>
          <Link to="/decouvrir" className="btn secondary">{t('nav.discover')}</Link>
        </div>
      </section>
    </div>
  );
}
